<div class="dialog-container">
  <div class="header">
    <div class="title">Warning: Unsaved Data</div>
  </div>
  <mat-divider></mat-divider>
  <p class="body p5">This page has unsaved data. Are you sure you want to navigate away?</p>
  <div class="buttons">
    <button [mat-dialog-close]="true" color="primary" data-cy="button-delete-changes" mat-stroked-button>
      Yes, Delete Changes
    </button>
    <button color="primary" [mat-dialog-close]="false" mat-flat-button>No, Stay</button>
  </div>
</div>
